import JsBarcode from "jsbarcode"
import QRCode from 'qrcode'
import { DeviceUtil, GeometryUtil } from "./control.util"
import { CanvasDraw } from "./layout.canvas"
import { Constant } from "./layout.constant"
import { LayoutElement } from "./layout.element"
import { Clipboard } from "./layout.util"

class MainLayout {
    static MOUSE_INSERT_MOVE = "insert-move"
    static MOUSE_SELECT_MOVE = "select-move"
    static MOUSE_SELECT_DRAG = "select-drag"
    static MOUSE_UNSELECT_MOVE = "unselect-move"

    #canvas
    #ratio
    #data
    #width
    #height

    //鼠标状态
    #mouseMoving
    #mouseMoveType
    #mouseBeginEvent
    #mouseLastEvent
    #mouseMoveDragPoint

    //元素操作
    #insertElement
    #selectElements

    //回调事件
    #selectCallback
    #messageCallback
    #cacheCallback

    //缓存堆栈
    #cachestack

    create(options) {
        this.#initUI(options)
    }

    importData(data) {
        this.#data = JSON.parse(data)
        this.#selectElements = []
        this.#pretreatmentVer()
        this.#pretreatmentData()
        this.#cachestack = []
        this.#saveCacheStack();
        this.#callbackTarget(this.#data)
    }


    getData() {
        return this.#data
    }

    addLine(type) {
        this.#insertElement = LayoutElement.defaultLineElement(type)
    }

    addText() {
        this.#insertElement = LayoutElement.defaultTextElement()
    }

    addPicture(value) {
        this.#insertElement = Object.assign(LayoutElement.defaultImageElement(), { code: value });
        this.#loadImageCache(value, (img) => {
            this.#insertElement.img = img
        })
    }

    addBarcode(value) {
        this.#insertElement = Object.assign(LayoutElement.defaultBarcodeElement(), { code: value });
        this.#loadBarcodeElement(value, (img) => {
            this.#insertElement.img = img
        })
    }

    addQrcode(value) {
        this.#insertElement = Object.assign(LayoutElement.defaultQrcodeElement(), { code: value });
        this.#loadQrcodeElement(value, (img) => {
            this.#insertElement.img = img
        })
    }

    addChromato(value) {
        this.#data.bgimg.base64 = value
        this.#loadImageCache(value, (img) => {
            this.#data.bgimg.img = img
            this.#drawCanvas()
        })
    }

    insertList(cols) {
        const newcols = []
        cols.forEach(col => {
            newcols.push(Object.assign(LayoutElement.defaultListColElement(), col))
        })
        this.#insertElement = Object.assign(LayoutElement.defaultListElement(), { cols: newcols });
    }

    updateListCols(element, cols) {
        const newcols = []
        cols.forEach(col => {
            newcols.push(Object.assign(LayoutElement.defaultListColElement(), col))
        })
        element.cols = newcols
        this.#drawCanvas()
        this.#saveCacheStack();
    }

    updateElement(element, field, value) {
        element[field] = value
        if (element.cls == LayoutElement.ELEMENT_QRCODE && field == 'code') {
            this.#loadQrcodeElement(value, (img) => {
                element.img = img
                this.refresh()
            })
        } else if (element.cls == LayoutElement.ELEMENT_BARCODE && field == 'code') {
            this.#loadBarcodeElement(value, (img) => {
                element.img = img
                this.refresh()
            })
        } else {
            this.refresh()
        }
    }

    deleteElements() {
        if (this.#selectElements.length > 0) {
            this.#selectElements.forEach(element => {
                const index = this.#data.children.findIndex(ele => ele === element)
                if (index >= 0) {
                    this.#data.children.splice(index, 1);
                }
            })
            this.#resetSelects()
            this.#drawCanvas()
            this.#saveCacheStack();
            this.#triggerSelectElements();
        }
    }

    alineTop() {
        if (this.#selectElements.length > 1) {
            const val = this.#selectElements[0].ay1
            this.#selectElements.forEach(element => {
                const deviation = val - element.ay1
                element.ay1 = val
                element.ay2 += deviation
            })
            this.#drawCanvas()
            this.#saveCacheStack();
        }
    }

    alineBottom() {
        if (this.#selectElements.length > 0) {
            const val = this.#selectElements[0].ay2
            this.#selectElements.forEach(element => {
                const deviation = val - element.ay2
                element.ay2 = val
                element.ay1 += deviation
            })
            this.#drawCanvas()
            this.#saveCacheStack();
        }
    }

    alineLeft() {
        if (this.#selectElements.length > 0) {
            const val = this.#selectElements[0].ax1
            this.#selectElements.forEach(element => {
                const deviation = val - element.ax1
                element.ax1 = val
                element.ax2 += deviation
            })
            this.#drawCanvas()
            this.#saveCacheStack();
        }
    }

    alineRight() {
        if (this.#selectElements.length > 0) {
            const val = this.#selectElements[0].ax2
            this.#selectElements.forEach(element => {
                const deviation = val - element.ax2
                element.ax2 = val
                element.ax1 += deviation
            })
            this.#drawCanvas()
            this.#saveCacheStack();
        }
    }

    moveup() {
        if (this.#selectElements.length == 1) {
            const ele = this.#selectElements[0]
            const index = this.#data.children.findIndex(e => e === ele)
            if (index < this.#data.children.length - 1) {
                this.#data.children.splice(index, 1)
                this.#data.children.splice(index + 1, 0, ele)
                this.#drawCanvas()
                this.#saveCacheStack();
            }
        }
    }

    movedown() {
        if (this.#selectElements.length == 1) {
            const ele = this.#selectElements[0]
            const index = this.#data.children.findIndex(e => e === ele)
            if (index > 0) {
                this.#data.children.splice(index, 1)
                this.#data.children.splice(index - 1, 0, ele)
                this.#drawCanvas()
                this.#saveCacheStack();
            }
        }
    }



    refresh() {
        this.#drawCanvas()
    }

    rollback() {
        this.#rollbackCacheStack()
    }

    savecache() {
        this.#saveCacheStack()
    }


    #initUI(options) {
        this.#canvas = document.createElement("canvas")
        this.#canvas.setAttribute('tabindex', '0');
        options.container.innerHTML = ""
        options.container.appendChild(this.#canvas);
        this.#ratio = 1
        this.#data = Object.assign(LayoutElement.defaultTemplet(), { version: Constant.SYS_VERSION })
        this.#mouseMoving = false
        this.#cachestack = []
        this.#selectElements = []
        this.#selectCallback = options.selectCallback
        this.#messageCallback = options.messageCallback
        this.#cacheCallback = options.cacheCallback

        this.#callbackTarget(this.#data)
        this.#addEvent()
        this.#drawCanvas()
        this.#saveCacheStack();
    }

    #addEvent() {
        document.addEventListener('paste', async (e) => {
            this.#pasteSelectElements(e)
        });
        document.addEventListener('copy', async (e) => {
            this.#copySelectElements(e)
        });
        window.addEventListener("mouseup", (e) => {
            this.#canvasMouseup(e)
        })
        window.addEventListener("keydown", (e) => {
            this.#canvasKeydown(e);
        })
        this.#canvas.addEventListener("mousedown", (e) => {
            this.#canvas.focus();
            if (e.button == 0) {
                e.preventDefault();
                this.#canvasMousedown(e)
            } else {
                e.preventDefault();
            }
        })
        this.#canvas.addEventListener("mousemove", (e) => {
            e.preventDefault();
            if (this.#mouseMoving) {
                this.#canvasMousemove(e)
            }
        })
        this.#canvas.addEventListener("mouseup", (e) => {
            this.#canvasMouseup(e)
        })
    }

    #resetSelects() {
        this.#selectElements = []
    }

    #putSelects(element) {
        this.#selectElements.push(element)
    }

    #callbackTarget(target) {
        this.#selectCallback(target)
    }

    #drawCanvas() {
        this.#width = (DeviceUtil.mmConversionPx(this.#data.width) * this.#ratio)
        this.#height = (DeviceUtil.mmConversionPx(this.#data.height) * this.#ratio)
        if (this.#data.direction == Constant.DIRECTION_PORTRAIT) {
            this.#canvas.width = `${this.#width}`
            this.#canvas.height = `${this.#height}`
            this.#canvas.style.width = `${this.#width}px`
            this.#canvas.style.height = `${this.#height}px`
        } else {
            this.#canvas.width = `${this.#height}`
            this.#canvas.height = `${this.#width}`
            this.#canvas.style.width = `${this.#height}px`
            this.#canvas.style.height = `${this.#width}px`
        }
        console.time("drawPaper");
        this.#drawPaper()
        console.timeEnd("drawPaper");
        console.time("drawElements");
        this.#drawElements()
        console.timeEnd("drawElements");
        console.time("drawMouseRect");
        this.#drawMouseRect()
        console.timeEnd("drawMouseRect");
    }

    #drawPaper() {
        if (this.#data.bgimg.base64 && this.#data.bgshow) {
            CanvasDraw.drawBackgroundImage(this.#canvas, this.#data.bgimg.img, this.#width, this.#height, this.#data.direction)
        }
    }

    #drawElements() {
        this.#data.children.forEach(element => {
            if (element.cls == LayoutElement.ELEMENT_LINE) {
                CanvasDraw.drawLine(this.#canvas, element)
            } else if (element.cls == LayoutElement.ELEMENT_TEXT) {
                CanvasDraw.drawText(this.#canvas, element)
            } else if (element.cls == LayoutElement.ELEMENT_IMAGE) {
                CanvasDraw.drawImage(this.#canvas, element)
            } else if (element.cls == LayoutElement.ELEMENT_BARCODE) {
                CanvasDraw.drawBarcode(this.#canvas, element)
            } else if (element.cls == LayoutElement.ELEMENT_QRCODE) {
                CanvasDraw.drawQrcode(this.#canvas, element)
            } else if (element.cls == LayoutElement.ELEMENT_LIST) {
                CanvasDraw.drawList(this.#canvas, element)
            }
        });
        this.#selectElements.forEach(element => {
            if (element.cls == LayoutElement.ELEMENT_LINE) {
                CanvasDraw.drawDragLinePoint(this.#canvas, element)
            } else if (element.cls == LayoutElement.ELEMENT_TEXT
                || element.cls == LayoutElement.ELEMENT_IMAGE
                || element.cls == LayoutElement.ELEMENT_BARCODE
                || element.cls == LayoutElement.ELEMENT_QRCODE
                || element.cls == LayoutElement.ELEMENT_LIST) {
                CanvasDraw.drawDragRectPoint(this.#canvas, element)
            }
        })
    }

    #drawMouseRect() {
        if (this.#mouseBeginEvent && this.#mouseLastEvent && this.#mouseMoveType == 'unselect-move') {
            const point1 = this.#convertPoint(this.#mouseBeginEvent)
            const point2 = this.#convertPoint(this.#mouseLastEvent)
            CanvasDraw.drawRectPoint(this.#canvas, point1, point2)
        }
    }

    #canvasKeydown(e) {
        if (this.#canvas !== document.activeElement) {
            return;
        }
        if (e.code == 'Delete') {
            this.deleteElements()
        } if (e.ctrlKey && e.code == 'ArrowUp') {
            this.#moveSelectElements("up");
        } else if (e.ctrlKey && e.code == 'ArrowLeft') {
            this.#moveSelectElements("left");
        } else if (e.ctrlKey && e.code == 'ArrowRight') {
            this.#moveSelectElements("right");
        } else if (e.ctrlKey && e.code == 'ArrowDown') {
            this.#moveSelectElements("down");
        }
    }

    #canvasMousedown(e) {
        console.info("canvasMousedown beg")
        this.#mouseBeginEvent = e
        this.#mouseLastEvent = e
        const point = this.#convertPoint(e)
        this.#mouseMoving = true
        if (this.#insertElement) {
            //有待插入的元素,初始化定位等,加入选中
            this.#resetSelects()
            this.#putSelects(this.#insertElement)
            this.#insertElement.ax1 = point.offsetX
            this.#insertElement.ay1 = point.offsetY
            this.#insertElement.ax2 = point.offsetX
            this.#insertElement.ay2 = point.offsetY
            this.#data.children.push(this.#insertElement)
            this.#mouseMoveType = MainLayout.MOUSE_INSERT_MOVE
            this.#triggerSelectElements();
            this.#insertElement = undefined
        } else {
            if (this.#selectElements.length == 0) {//当前无选中
                this.#canvasMouseSelect(e)
            } else if (this.#selectElements.length == 1) {//有选中一个
                const hits = this.#hitElementDrag(point);
                if (hits == 0) {
                    this.#mouseMoveType = MainLayout.MOUSE_SELECT_MOVE
                } else if (hits > 0) {
                    this.#mouseMoveType = MainLayout.MOUSE_SELECT_DRAG
                    this.#mouseMoveDragPoint = hits
                } else {
                    this.#canvasMouseSelect(e)
                }
            } else {//有选中多个
                if (this.#hitElementSelected(point)) {

                    this.#mouseMoveType = MainLayout.MOUSE_SELECT_MOVE
                } else {
                    this.#canvasMouseSelect(e)
                }
            }
        }
        this.#drawCanvas()
        console.info("canvasMousedown end")
    }


    /**
     * 根据点击判断是否击中中元素
     * 
     * @param {*} e 
     */
    #canvasMouseSelect(e) {
        if (!e.ctrlKey) {
            this.#resetSelects()
        }
        const point = this.#convertPoint(e)
        const element = this.#hitElement(point)
        if (element) {
            this.#putSelects(element)
            this.#mouseMoveType = MainLayout.MOUSE_SELECT_MOVE
        } else {
            this.#mouseMoveType = MainLayout.MOUSE_UNSELECT_MOVE
        }
        this.#triggerSelectElements();
    }

    /**
     * 鼠标滑动选中元素
     */
    #canvasMouseRectelect() {
        const beginpoint = this.#convertPoint(this.#mouseBeginEvent)
        const endpoint = this.#convertPoint(this.#mouseLastEvent)
        this.#scanElement(beginpoint, endpoint)
        this.#triggerSelectElements();
    }

    #canvasMousemove(e) {
        console.info("canvasMousemove beg")
        const point = this.#convertPoint(e)
        const lastPoint = this.#convertPoint(this.#mouseLastEvent)
        if (this.#mouseMoveType == MainLayout.MOUSE_INSERT_MOVE) {
            this.#selectElements[0].ax2 = DeviceUtil.round(point.offsetX)
            this.#selectElements[0].ay2 = DeviceUtil.round(point.offsetY)
        } else if (this.#mouseMoveType == MainLayout.MOUSE_SELECT_MOVE) {
            this.#selectElements.forEach(element => {
                element.ax1 = DeviceUtil.round(element.ax1 + point.offsetX - lastPoint.offsetX)
                element.ay1 = DeviceUtil.round(element.ay1 + point.offsetY - lastPoint.offsetY)
                element.ax2 = DeviceUtil.round(element.ax2 + point.offsetX - lastPoint.offsetX)
                element.ay2 = DeviceUtil.round(element.ay2 + point.offsetY - lastPoint.offsetY)
            })
        } else if (this.#mouseMoveType == MainLayout.MOUSE_SELECT_DRAG) {
            if (this.#mouseMoveDragPoint == 1) {
                this.#selectElements[0].ax1 = DeviceUtil.round(this.#selectElements[0].ax1 + point.offsetX - lastPoint.offsetX)
                this.#selectElements[0].ay1 = DeviceUtil.round(this.#selectElements[0].ay1 + point.offsetY - lastPoint.offsetY)
            } else if (this.#mouseMoveDragPoint == 2) {
                this.#selectElements[0].ax2 = DeviceUtil.round(this.#selectElements[0].ax2 + point.offsetX - lastPoint.offsetX)
                this.#selectElements[0].ay1 = DeviceUtil.round(this.#selectElements[0].ay1 + point.offsetY - lastPoint.offsetY)
            } else if (this.#mouseMoveDragPoint == 3) {
                this.#selectElements[0].ax2 = DeviceUtil.round(this.#selectElements[0].ax2 + point.offsetX - lastPoint.offsetX)
                this.#selectElements[0].ay2 = DeviceUtil.round(this.#selectElements[0].ay2 + point.offsetY - lastPoint.offsetY)
            } else if (this.#mouseMoveDragPoint == 4) {
                this.#selectElements[0].ax1 = DeviceUtil.round(this.#selectElements[0].ax1 + point.offsetX - lastPoint.offsetX)
                this.#selectElements[0].ay2 = DeviceUtil.round(this.#selectElements[0].ay2 + point.offsetY - lastPoint.offsetY)
            }
        } else if (this.#mouseMoveType == MainLayout.MOUSE_UNSELECT_MOVE) {

        }
        this.#triggerSelectElements();
        this.#mouseLastEvent = e
        this.#drawCanvas()
        console.info("canvasMousemove end")
    }

    #canvasMouseup(e) {
        console.info("canvasMouseup beg")
        if (this.#mouseMoveType == MainLayout.MOUSE_INSERT_MOVE) {
            const ele = this.#selectElements[0]
            if (ele.ax2 - ele.ax1 < Constant.DRAG_MIN_LEN && ele.ay2 - ele.ay1 < Constant.DRAG_MIN_LEN) {
                ele.ax2 += Constant.RECT_DEF_WIDTH
                ele.ay2 += Constant.RECT_DEF_HEIGHT
            }
            this.#saveCacheStack();
        } else if (this.#mouseMoveType == MainLayout.MOUSE_SELECT_MOVE) {
            if (Math.abs(this.#mouseBeginEvent.offsetX - this.#mouseLastEvent.offsetX) + Math.abs(this.#mouseBeginEvent.offsetY - this.#mouseLastEvent.offsetY) > 4) {
                this.#saveCacheStack();
            }
        } else if (this.#mouseMoveType == MainLayout.MOUSE_SELECT_DRAG) {
            if (Math.abs(this.#mouseBeginEvent.offsetX - this.#mouseLastEvent.offsetX) + Math.abs(this.#mouseBeginEvent.offsetY - this.#mouseLastEvent.offsetY) > 4) {
                this.#saveCacheStack();
            }
        } else if (this.#mouseMoveType == MainLayout.MOUSE_UNSELECT_MOVE) {
            this.#canvasMouseRectelect()
        }
        this.#mouseMoving = false
        this.#mouseMoveType = undefined
        this.#mouseBeginEvent = undefined
        this.#mouseLastEvent = undefined
        this.#drawCanvas()
        console.info("canvasMouseup end")
    }

    #moveSelectElements(aw) {
        const setp = 0.2
        this.#selectElements.forEach(ele => {
            if (aw == 'up') {
                ele.ay1 -= setp
                ele.ay2 -= setp
            } else if (aw == 'down') {
                ele.ay1 += setp
                ele.ay2 += setp
            } else if (aw == 'left') {
                ele.ax1 -= setp
                ele.ax2 -= setp
            } else if (aw == 'right') {
                ele.ax1 += setp
                ele.ax2 += setp
            }
        })
        if (this.#selectElements.length > 0) {
            this.#drawCanvas();
        }
    }

    #copySelectElements(e) {
        if (this.#canvas !== document.activeElement) {
            return;
        }
        e.preventDefault();
        if (this.#selectElements.length > 0) {
            const object = {
                flag: 'peach-printer-copy',
                elements: this.#selectElements
            }
            try {
                const clipboardData = e.clipboardData || window.clipboardData;
                clipboardData.setData('application/peach-copy-data', JSON.stringify(object));
                this.#messageCallback("复制成功")
            } catch (err) {
                this.#messageCallback("复制失败")
            }
        }
    }

    #pasteSelectElements(e) {
        if (this.#canvas !== document.activeElement) {
            return;
        }
        e.preventDefault();
        try {
            const clipboardData = e.clipboardData || window.clipboardData;
            // 获取 HTML（如果存在）
            const base = clipboardData.getData('application/peach-copy-data');
            if (base) {
                try {
                    const object = JSON.parse(base)
                    if (object.flag == 'peach-printer-copy') {

                        const elements = []
                        object.elements.forEach(ele => {
                            ele.ax1 += 4
                            ele.ax2 += 4
                            ele.ay1 += 4
                            ele.ay2 += 4
                            this.#data.children.push(ele)
                            elements.push(ele)
                        })
                        Clipboard.copy(JSON.stringify(object)).then(() => { })
                        this.#selectElements = elements
                        this.#drawCanvas()
                        this.#triggerSelectElements();
                    } else {
                        this.#messageCallback("无法解析的字符串2")
                    }
                } catch (error) {
                    this.#messageCallback("无法解析的字符串")
                }
            }
        } catch (err) {
            this.#messageCallback("粘贴失败")
        }

    }


    //触发前段组件显示
    #triggerSelectElements() {
        if (this.#selectElements.length == 1) {
            this.#callbackTarget(this.#selectElements[0])
        } else {
            this.#callbackTarget(this.#data)
        }
    }

    #saveCacheStack() {
        const stack = {
            data: this.#data,
            selectIndexs: []
        }
        this.#selectElements.forEach(ele => {
            stack.selectIndexs.push(this.#data.children.findIndex(i => i === ele))
        })
        this.#cachestack.push(JSON.stringify(stack))
        this.#cacheCallback(this.#cachestack.length > 1)
    }

    #rollbackCacheStack() {
        this.#cachestack.pop()
        if (this.#cachestack.length > 0) {
            const stack = JSON.parse(this.#cachestack.at(-1))
            this.#data = stack.data
            this.#selectElements = []
            stack.selectIndexs.forEach(index => {
                this.#selectElements.push(this.#data.children[index])
            })
            this.#drawCanvas()
            this.#triggerSelectElements()
        }
        this.#cacheCallback(this.#cachestack.length > 1)
    }

    /**
     * 是否击中某个元素
     * 
     * @param {*} e 
     */
    #hitElement(pt) {
        for (let index = this.#data.children.length - 1; index >= 0; index--) {
            const element = this.#data.children[index];
            if (element.cls == LayoutElement.ELEMENT_LINE) {
                if (element.type == '1') {
                    if (GeometryUtil.pointToEllipseDistance(pt.offsetX, pt.offsetY, element.ax1, element.ay1, element.ax2, element.ay2) < Constant.POINT_SELECT_DISTANCE) {
                        return element
                    }
                } else if (element.type == '2') {
                    if (GeometryUtil.pointToRectDistance(pt.offsetX, pt.offsetY, element.ax1, element.ay1, element.ax2, element.ay2) < Constant.POINT_SELECT_DISTANCE) {
                        return element
                    }
                } else {
                    if (GeometryUtil.pointToLineDistance(pt.offsetX, pt.offsetY, element.ax1, element.ay1, element.ax2, element.ay2) < Constant.POINT_SELECT_DISTANCE) {
                        return element
                    }
                }
            } else if (element.cls == LayoutElement.ELEMENT_TEXT
                || element.cls == LayoutElement.ELEMENT_IMAGE
                || element.cls == LayoutElement.ELEMENT_BARCODE
                || element.cls == LayoutElement.ELEMENT_QRCODE
                || element.cls == LayoutElement.ELEMENT_LIST) {
                if (GeometryUtil.pointInRect(pt.offsetX, pt.offsetY, element.ax1, element.ay1, element.ax2, element.ay2)) {
                    return element
                }
            }
        }
    }

    /**
     * 是否击中选中元素集合
     * 
     * @param {*} pt 
     * @returns 
     */
    #hitElementSelected(pt) {
        return this.#selectElements.find(element => {
            if (element.cls == LayoutElement.ELEMENT_LINE) {
                if (GeometryUtil.pointToLineDistance(pt.offsetX, pt.offsetY, element.ax1, element.ay1, element.ax2, element.ay2) < Constant.POINT_SELECT_DISTANCE) {
                    return true
                }
                if (LayoutElement.hitLineDragType(pt, element) >= 0) {
                    return true
                }
            } else if (element.cls == LayoutElement.ELEMENT_TEXT
                || element.cls == LayoutElement.ELEMENT_IMAGE
                || element.cls == LayoutElement.ELEMENT_BARCODE
                || element.cls == LayoutElement.ELEMENT_QRCODE
                || element.cls == LayoutElement.ELEMENT_LIST) {
                if (GeometryUtil.pointInRect(pt.offsetX, pt.offsetY, element.ax1, element.ay1, element.ax2, element.ay2)) {
                    return true
                }
                if (LayoutElement.hitRectDragType(pt, element) >= 0) {
                    return true
                }
            }
        })
    }

    /**
     * 是否击中元素的拖拽点
     * 
     * @param {*} pt 
     */
    #hitElementDrag(pt) {
        const selected = this.#selectElements[0]
        if (selected.cls == LayoutElement.ELEMENT_LINE) {
            return LayoutElement.hitLineDragType(pt, selected)
        } else if (selected.cls == LayoutElement.ELEMENT_TEXT
            || selected.cls == LayoutElement.ELEMENT_IMAGE
            || selected.cls == LayoutElement.ELEMENT_BARCODE
            || selected.cls == LayoutElement.ELEMENT_QRCODE
            || selected.cls == LayoutElement.ELEMENT_LIST) {
            return LayoutElement.hitRectDragType(pt, selected)
        }
    }

    #scanElement(point1, point2) {
        this.#data.children.forEach(element => {
            if (element.cls == LayoutElement.ELEMENT_LINE) {
                if (LayoutElement.contactLineElement(point1, point2, element)) {
                    this.#selectElements.push(element)
                }
            } else if (element.cls == LayoutElement.ELEMENT_TEXT
                || element.cls == LayoutElement.ELEMENT_IMAGE
                || element.cls == LayoutElement.ELEMENT_BARCODE
                || element.cls == LayoutElement.ELEMENT_QRCODE
                || element.cls == LayoutElement.ELEMENT_LIST) {

                if (LayoutElement.contactRectElement(point1, point2, element)) {
                    this.#selectElements.push(element)
                }
            }
        })
    }

    /**
     * 预处理元素数据
     */
    #pretreatmentData() {
        this.#data.children = this.#data.children.map(element => {
            element.ax1 = DeviceUtil.round(element.ax1)
            element.ax2 = DeviceUtil.round(element.ax2)
            element.ay1 = DeviceUtil.round(element.ay1)
            element.ay2 = DeviceUtil.round(element.ay2)
            if (element.cls == LayoutElement.ELEMENT_LINE) {
                return Object.assign(LayoutElement.defaultLineElement(), element)
            } else if (element.cls == LayoutElement.ELEMENT_TEXT) {
                return Object.assign(LayoutElement.defaultTextElement(), element)
            } else if (element.cls == LayoutElement.ELEMENT_IMAGE) {
                return Object.assign(LayoutElement.defaultImageElement(), element)
            } else if (element.cls == LayoutElement.ELEMENT_QRCODE) {
                return Object.assign(LayoutElement.defaultQrcodeElement(), element)
            } else if (element.cls == LayoutElement.ELEMENT_BARCODE) {
                return Object.assign(LayoutElement.defaultBarcodeElement(), element)
            } else if (element.cls == LayoutElement.ELEMENT_LIST) {
                const newele = Object.assign(LayoutElement.defaultListElement(), element);
                newele.cols = newele.cols.map(col => {
                    return Object.assign(LayoutElement.defaultListColElement(), col);
                })
                return newele
            } else {
                return element
            }
        })
        if (this.#data.bgimg.base64) {
            this.#loadImageCache(this.#data.bgimg.base64, (img) => {
                this.#data.bgimg.img = img
                this.#loadImageElementCache(this.#data.children, 0, () => {
                    this.#drawCanvas()
                })
            })
        } else {
            this.#loadImageElementCache(this.#data.children, 0, () => {
                this.#drawCanvas()
            })
        }
    }

    /**
     * 预处理版本信息
     */
    #pretreatmentVer() {
        this.#data = Object.assign(LayoutElement.defaultTemplet(), this.#data)
        if (this.#data.version == 0) {
            //
        }
        this.#data.version = Constant.SYS_VERSION
    }

    /**
     * 导入数据后加载图像缓存
     * 
     * @param {*} elements 
     * @param {*} index 
     * @param {*} callback 
     */
    #loadImageElementCache(elements, index, callback) {
        const ele = elements[index]

        //调到下一个的公共方法
        const next = (elements, index, callback) => {
            if (index < elements.length - 1) {
                this.#loadImageElementCache(elements, index + 1, callback)
            } else {
                callback()
            }
        }

        //当前元素判断
        if (ele.cls == LayoutElement.ELEMENT_IMAGE) {
            this.#loadImageCache(ele.code, (img) => {
                ele.img = img
                next(elements, index, callback)
            })
        } else if (ele.cls == LayoutElement.ELEMENT_BARCODE) {
            this.#loadBarcodeElement(ele.code, (img) => {
                ele.img = img
                next(elements, index, callback)
            })
        } else if (ele.cls == LayoutElement.ELEMENT_QRCODE) {
            this.#loadQrcodeElement(ele.code, (img) => {
                ele.img = img
                next(elements, index, callback)
            })
        } else {
            next(elements, index, callback)
        }
    }

    /**
     * 加载image类型元素缓存
     * @param {*} value 
     * @param {*} callback 
     */
    #loadImageCache(value, callback) {
        const img = new Image();
        img.src = value
        img.onload = () => {
            callback(img)
        };
    }

    /**
     * 加载barcode类型元素缓存
     * @param {*} value 
     * @param {*} callback 
     */
    #loadBarcodeElement(value, callback) {
        const img = new Image();
        JsBarcode(img, value);
        img.onload = () => {
            callback(img)
        }
    }

    #loadQrcodeElement(value, callback) {
        QRCode.toDataURL(value).then(src => {
            const img = new Image();
            img.src = src
            img.onload = () => {
                callback(img)
            };
        }).catch(err => {

        })
    }

    #convertPoint(e) {
        const point = {
            offsetX: DeviceUtil.pxConversionDc(e.offsetX / this.#ratio),
            offsetY: DeviceUtil.pxConversionDc(e.offsetY / this.#ratio),
        }
        if (isNaN(point.offsetX) || isNaN(point.offsetY)) {
            console.info(point)
        }
        return point
    }
}

export {
    MainLayout
}